module.exports = __webpack_public_path__ + "img/gray-outline-heart.a4f4160f.svg";